import { render, staticRenderFns } from "./ModalBundleSKU.vue?vue&type=template&id=8146087c&scoped=true&"
import script from "./ModalBundleSKU.vue?vue&type=script&lang=js&"
export * from "./ModalBundleSKU.vue?vue&type=script&lang=js&"
import style0 from "./ModalBundleSKU.vue?vue&type=style&index=0&id=8146087c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8146087c",
  null
  
)

export default component.exports